import { anfrage } from "./basis.ts";

export interface BestellgruppenMitglied {
  orderId: string;
  membershipState: "active" | "retained" | "removed";
}

export interface BestellgruppenDokument {
  documentId: string;
  docType: string;
  status: string;
}

export interface Bestellgruppe {
  id: string;
  kLieferant: number;
  shipmentId: string | null;
  status: "active" | "dissolved";
  rowVersion: number;
  members: BestellgruppenMitglied[];
  documents: BestellgruppenDokument[];
}

export interface BestellgruppenVergleich {
  groupOrderIds: string[];
  shipmentOrderIds: string[];
  onlyInGroup: string[];
  onlyInShipment: string[];
}

export function bestellgruppeAnlegen(
  orderIds: readonly string[],
  expectedOrderVersions: Record<string, number>,
): Promise<Bestellgruppe> {
  return anfrage<Bestellgruppe>("/api/order-groups", {
    methode: "POST",
    koerper: { orderIds, expectedOrderVersions },
  });
}

export function bestellgruppeLaden(groupId: string, signal?: AbortSignal): Promise<Bestellgruppe> {
  return anfrage<Bestellgruppe>(`/api/order-groups/${encodeURIComponent(groupId)}`, { signal });
}

export function bestellgruppenMitgliedHinzufuegen(
  groupId: string,
  orderId: string,
  expectedGroupVersion: number,
  expectedOrderVersions: Record<string, number>,
): Promise<Bestellgruppe> {
  return anfrage<Bestellgruppe>(`/api/order-groups/${encodeURIComponent(groupId)}/members`, {
    methode: "POST",
    koerper: { orderId, expectedGroupVersion, expectedOrderVersions },
  });
}

export function bestellgruppenMitgliedLoesen(
  groupId: string,
  orderId: string,
  expectedGroupVersion: number,
  expectedOrderVersions: Record<string, number>,
): Promise<Bestellgruppe> {
  return anfrage<Bestellgruppe>(
    `/api/order-groups/${encodeURIComponent(groupId)}/members/${encodeURIComponent(orderId)}`,
    { methode: "DELETE", koerper: { expectedGroupVersion, expectedOrderVersions } },
  );
}

export function bestellgruppeAufloesen(
  groupId: string,
  retainedOrderIds: readonly string[],
  expectedGroupVersion: number,
  expectedOrderVersions: Record<string, number>,
): Promise<Bestellgruppe> {
  return anfrage<Bestellgruppe>(`/api/order-groups/${encodeURIComponent(groupId)}/dissolve`, {
    methode: "POST",
    koerper: { retainedOrderIds, expectedGroupVersion, expectedOrderVersions },
  });
}

export function bestellgruppenSendungSetzen(
  groupId: string,
  shipmentId: string | null,
  expectedGroupVersion: number,
  expectedOrderVersions: Record<string, number>,
): Promise<Bestellgruppe> {
  return anfrage<Bestellgruppe>(`/api/order-groups/${encodeURIComponent(groupId)}/shipment`, {
    methode: "PUT",
    koerper: { shipmentId, expectedGroupVersion, expectedOrderVersions },
  });
}

export function bestellgruppenVergleichLaden(
  groupId: string,
  shipmentId: string,
  signal?: AbortSignal,
): Promise<BestellgruppenVergleich> {
  return anfrage<BestellgruppenVergleich>(
    `/api/order-groups/${encodeURIComponent(groupId)}/shipment-comparison?shipmentId=${encodeURIComponent(shipmentId)}`,
    { signal },
  );
}
